//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PortalFileUpload from "@/pcpage/hr/recruitment/portal/component/PortalFileUpload";
import { rec } from "@/lang/zh";
import NoDataDisplay from "@/pccomponents/NoDataDisplay";
import ffapplydept from "@/pccomponents/ffapplydept";

export default {
  components: {
    PortalFileUpload,
    NoDataDisplay,
    ffapplydept,
  },
  props: {
    width: {
      type: String,
      default: "50%",
    },
  },
  data() {
    return {
      dialogVisible: false,
      type: "",
      radio: "",
      textarea: "",
      valueKey: {
        payslipsUpload: {
          title: "Payslips Upload",
          note: "Please upload your most recent two months payslips",
          submitMethod: "toPayslipsUpload",
        },
        offerAcceptance: {
          title: "Offer Acceptance",
          note: 'Click "View Offer Details" to see offer in new browser tag',
          submitMethod: "toOfferAcceptance",
        },
        AttachmentHistory: {
          title: "Attachment History",
        },
      },

      toDoData: {},
      fileOfferProcessForm: {
        docutypeid: "offerprocess",
        keyval: "",
        btype: "HIRING_OFFER_PROCESS",
      },
      getFileListUrl: "api/api/portalFile/getFileInfos",
      fileList: [],
      portalfilelist: [],
    };
  },
  methods: {
    init(type, item) {
      this.type = type;
      this.dialogVisible = true;
      this.toDoData = item;
      if (type == "AttachmentHistory") {
        this.getFileList("portalfilelist", "bportaluser", "portal");
      } else {
        this.getFileList("fileList", "bhiringofferprocess", "offerprocess");
      }
    },
    submitMethod() {
      this[this.valueKey[this.type].submitMethod]();
    },

    async toPayslipsUpload() {
      if (this.fileList.length == 0) {
        alert("Please upload file.");
        return false;
      }
      let flag = await this.tipCustomConfirmNew(
        "default",
        "Are you sure to submit?",
        ""
      ).then((res) => {
        return res;
      });
      if (flag) {
        let url = "api/api/submitOfferProcess";
        let record = {
          type: "PayslipsUpload",
          uuid: this.toDoData.uuid,
        };
        let params = {
          record: record,
        };
        this.axios.post(url, params).then(({ data }) => {
          if (data.code == "1") {
            // 回调
            this.$emit("findOfferProcess");
            this.dialogVisible = false;
          }
        });
      }
    },

    async deleteAttachmentFile(item) {
      let flag = await this.tipCustomConfirmNew(
        "default",
        "Are you sure to delete the attachment?",
        ""
      ).then((res) => {
        return res;
      });
      if (flag) {
        let url = "/api/api/portalFile/delefilebyId";
        let ids = [];
        ids.push(item.fileid);
        let params = {
          delfileids: ids,
        };
        await this.axios
          .post(url, params)
          .then(({ data }) => {
            if ("1" === data.code) {
              this.getFileList("portalfilelist", "bportaluser", "portal");
              this.$parent.fileUploadBack();
            }
          })
          .catch((error) => console.log(error));
      }
    },

    changeRadio(value) {
      if (value == 3) {
        this.$set(this, 'textarea', '');
      }
    },

    async toOfferAcceptance() {
      if (!this.isNotNullOrEmpty(this.radio)) {
        this.$msgDailog.showMsgBox({title: "Please select your choice."});
        return false;
      }
      if (this.radio == 3 && !this.isNotNullOrEmpty(this.textarea)) {
        this.$msgDailog.showMsgBox({title: "Please fill in the reason."});
        return false;
      }
      let flag = await this.tipCustomConfirmNew(
        "default",
        "Are you sure to submit?",
        ""
      ).then((res) => {
        return res;
      });
      if (flag) {
        let url = "api/api/submitOfferProcess";
        let record = {
          type: "OfferAcceptance",
          uuid: this.toDoData.uuid,
          action: this.radio,
          reason: this.textarea,
        };
        let params = {
          record: record,
        };
        this.axios.post(url, params).then(({ data }) => {
          if (data.code == "1") {
            // 回调
            this.$emit("findOfferProcess");
            this.dialogVisible = false;
          }
        });
      }
    },

    fileUploadBack() {
      //文件上传回调
      this.getFileList("fileList", "bhiringofferprocess", "offerprocess");
    },

    async getFileList(objList, tagName, docuTypeId) {
      let email = this.toDoData.email;
      let resumeid;
      if (tagName == "bportaluser") {
        resumeid = this.toDoData.resumeid;
      } else {
        resumeid = this.toDoData.uuid;
      }
      if (!this.isNotNullOrEmpty(email)) {
        email = "";
      }
      if (!this.isNotNullOrEmpty(resumeid)) {
        resumeid = "";
      }
      let url = this.getFileListUrl;
      let params = {
        record: {
          keyval: resumeid,
          accountid: email,
          tagname: tagName,
          docutypeid: docuTypeId,
        },
      };
      await this.axios
        .post(url, params)
        .then(({ data }) => {
          if ("1" === data.code) {
            let fileList = data.data.record.filelist;
            this.$set(this, objList, fileList);
          }
        })
        .catch((error) => console.log(error));
    },

    async deleteFile(id) {
      let url = "/api/api/portalFile/delefilebyId";
      let ids = [];
      ids.push(id);
      let params = {
        delfileids: ids,
      };
      await this.axios
        .post(url, params)
        .then(({ data }) => {
          if ("1" === data.code) {
            this.getFileList("fileList", "bhiringofferprocess", "offerprocess");
          }
        })
        .catch((error) => console.log(error));
    },

    async viewOffer() {
      let oQuery = {};
      let routerpath = "/portal/offerprocess";
      oQuery["applicationUuid"] = this.toDoData.applicationUuid;
      this.openWin(routerpath, oQuery);
    },

    async download(link) {
      let url = "api/api/portalFile/download";
      let params = {
        fileid: link.fileid,
        filename: link.filename,
        url: link.url,
        uuid: link.fileid,
      };
      this.axios
        .posttype(url, { record: params }, "arraybuffer")
        .then((res) => {
          let blob = new Blob([res.data]);
          let url = window.URL.createObjectURL(blob); //表示一个指定的file对象或Blob对象
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          a.download = link.filename; //命名下载名称
          a.click(); //点击触发下载
          window.URL.revokeObjectURL(url); //下载完成进行释放
          document.body.removeChild(a);
        })
        .catch((error) => console.log(error));
    },
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/component/redBorderDialog.vue